export default "__VITE_ASSET__647e75eb__"